
<script>
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import AgendaForm from './agenda-form'
import { getText } from '../shared/utils'
import { objectToCsv, downloadCsvReport } from '../shared/csvReport'
import { apiDateORDS } from '../shared/api-functions'
import { SysVars } from '../main'

export default {
    data () {
        return {
            showForm: false, //exibe a tela de manutencao de nota de saida
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            filter: '',
            urlFilterMonth: '',
            metadata: this.$store.getters.getEntities.metadata,

            codagenda: null,
            tpAgenda: null,
            codusuario: null,

            showConcluidas: false,

            monthFilter: {},
        }
    },

    computed: {
        agendaList: function () {
            return this.$store.getters.getAgendaList
        },

        perfil_usuario_comum: function () {
            return this.$store.getters.getSessao.perfil == '3'
        },

        usuarioList: function () {
            //lista de usuarios para selecao
            let options = []
            for (var x = 0; x < this.$store.getters.getUsuarioList.length; x++) {
                options.push({ id: this.$store.getters.getUsuarioList[x].codusuario, text: this.$store.getters.getUsuarioList[x].nome })
            }
            return options
        },

    },

    watch: {
        codusuario: function () {
            this.loadData()
        },

        showConcluidas: function () {
            this.loadData()
        }

    },

    methods: {
        handleMonthChange() {
            this.urlFilterMonth = '{"dataagendada":{"$between":[{"$date":"' + apiDateORDS(this.monthFilter.startDate) + '"},{"$date":"' + apiDateORDS(this.monthFilter.endDate, true) + '"}]}}'
            this.loadData()
        },

        handleEdit (codagenda) {
            //abre a tela de edicao
            this.crud = SysVars.crudU //operacao de edicao
            this.codagenda = codagenda
            this.showForm = true; //exibe o form de manutencao
        },

        handleNew () {
            //abre a tela de edicao
            this.crud = SysVars.crudI //operacao de inclusao
            this.codagenda = null
            this.showForm = true //exibe o form de manutencao
        },

        closeForm() {
            this.showForm = false
            this.showFormImportXML = false
            this.loadData()
        },

        handleShowPainelCliente (codpart) {
          this.$router.push('/fv/clientes/painel/' + codpart)
        },

        handleSearch(value) {
            //efetua a pesquisa
            if (!value)
              this.filter = ''
            else
              this.filter = '{"$or":[{"nome":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        loadData() {
            let filter = this.filter
            if (this.urlFilterMonth) {
                if (filter)  
                    filter = filter + ','
                filter = filter + this.urlFilterMonth
            }

            if (filter)  
                filter = filter + ','
            if (this.showConcluidas) 
                filter = filter + '{"$or":[{"concluida":{"$eq":"S"}},{"concluida":{"$eq":"N"}}]}'
            else
                filter = filter + '{"$and":[{"concluida":{"$eq":"N"}}]}'
            
            if (this.codusuario) {
                if (filter)  
                    filter = filter + ','
                filter = filter + '{"$and":[{"codusuario":{"$eq":"' + this.codusuario + '"}}]}'
            }

            if (filter)
              filter = '{"$and":[' + filter + ']}'
            
            this.$store.dispatch('loadAgenda', { filter: filter} )

            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },

    },

    components: {
        BarList, BarGrid, AgendaForm
    },

    created () {
        //CARREGA LISTA DE USUARIOS
        this.$store.dispatch('loadUsuariosDashboard', this)

        this.loadData()
    }

}

</script>

<template>
    <div>
        <bar-list
            :refresh-button="true" 
            :new-button="false" 
            single-entity="Agenda" 
            plural-entity="Agenda"
            @refresh="loadData">
        </bar-list>
        <div class="mb-2">

        </div>
        <div id="list"> 
            <div class="default-container">
                <div class="row align-items-center">
                    <form-field v-model="codusuario" type="select" col="6" :select-options="usuarioList" placeholder="Todos os usuários"></form-field>
                    <div class="col-md-3 col-6">
                        <input-month :p-month="monthFilter" @monthChange="handleMonthChange"></input-month>
                    </div>
                    <div class="col-md-3 col-6 text-right">
                        <v-button label="Agenda" :nb-btdef="true" icon="fa-plus" @click="handleNew"></v-button>
                    </div>
                    <div class="col-md-12 col-12 mt-2">
                        <input-checkbox v-model="showConcluidas" :value-checked="true" :value-unchecked="false" label="Mostrar tarefas concluídas"></input-checkbox>
                    </div>
                </div>
            </div>

            <div class="default-container mt-2">
                <div v-if="agendaList.length == 0" class="no-content mb-4">Nenhuma atividade foi encontrada</div>
                <div class="mainbox" v-for="(item, index) in agendaList" :key="index">
                    <div class="box">
                        <div class="row align-items-center">
                            <div class="col-auto text-center">
                                <div class="list-icon">
                                    <i v-if="item.tpagenda == 'L'" class="fa fa-phone"></i>
                                    <i v-if="item.tpagenda == 'V'" class="fa fa-car"></i>
                                    <i v-if="item.tpagenda == 'A'" class="fa fa-tasks"></i>
                                </div>
                            </div>
                            <div class="col-md-10 col-8">
                                <div class="row">
                                    <div class="col-12" v-if="item.titulo">
                                        <span class="data-list"><strong>{{ item.titulo }}</strong></span>
                                    </div>
                                    <div class="col-12">
                                        <span class="lbl-list pr-3" :class=" {'atrasado': item.dias_atraso > 0 && item.concluida!='S' } "><i class="fa fa-calendar pr-2" aria-hidden="true"></i> {{ item.dataagendada | formatDataExtenso }}  {{ item.horaagendada }} </span>
                                        <span class="lbl-list pr-3"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i>{{ item.usuario_nome }}</span>
                                        <span class="badge badge-green mb-2 float-right" v-if="item.concluida=='S'" >Atividade Concluída</span>
                                        <!-- <span class="lbl-list pr-3"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> {{ item.dataagendada | formatDataExtenso }}  {{ item.horaagendada }} </span>
                                        <span class="lbl-list"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i> {{ item.usuario_nome }}</span>
                                        <span class="badge badge-green mb-2 float-right" v-if="item.concluida=='S'" >Atividade Concluída</span>
                                        <span class="badge badge-orange mb-2 float-right" v-if="item.concluida=='N' && item.dias_atraso <= 0" >Atividade Pendente</span>
                                        <span class="badge badge-red mb-2 float-right" v-if="item.concluida=='N' && item.dias_atraso > 0" >Atividade Atrasada</span> -->
                                    </div>
                                </div>
                                        <!-- <span v-if="item.nome" class="lbl-link" @click="handleShowPainelCliente(item.codpart)">{{ item.nome }}</span> -->
                                <div v-if="item.ende" class="row col">
                                    <span class="lbl-list"><i class="fa fa-location-arrow pr-2" aria-hidden="true"></i>{{ item.ende }} {{ item.endenr }}</span>
                                    <span v-if="item.bairro" class="lbl-list">- {{ item.bairro }}</span>
                                    <span v-if="item.nomemun" class="lbl-list">- {{ item.nomemun }}</span>
                                    <span class="lbl-list">- {{ item.uf }}</span>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <span class="lbl-list w-100">{{ item.texto }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <a v-if="item.pessoa_nome" class="data-list mr-2" :href="'#/crm/pessoa/'+item.codpessoa" data-toggle="tooltip" data-placement="top" :title="'Atividade vinculada à pessoa ' + item.pessoa_nome"><i class="fa fa-user mr-2" aria-hidden="true"></i>{{ item.pessoa_nome }}</a>
                                        <a v-if="item.org_nome" class="data-list mr-2" :href="'#/crm/organizacao/'+item.codorg" data-toggle="tooltip" data-placement="top" :title="'Atividade vinculada à organização ' + item.org_nome"><i class="fa fa-university mr-2" aria-hidden="true"></i>{{ item.org_nome }}</a>
                                        <a v-if="item.negocio_titulo" class="data-list mr-2" :href="'#/crm/negocio/'+item.codnegocio" data-toggle="tooltip" data-placement="top" :title="'Atividade vinculada ao negócio ' + item.negocio_titulo"><i class="fa fa-dollar mr-2" aria-hidden="true"></i>{{ item.negocio_titulo }}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-1 col-2">
                                <v-button label="" icon="fa-pencil" class="float-right" @click="handleEdit(item.codagenda)"></v-button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <transition name="fade">
            <agenda-form v-if="showForm" :index="codagenda" :crud="crud" @closeform="closeForm"></agenda-form>
        </transition>

    </div>
</template>


<style>
</style>



// WEBPACK FOOTER //
// src/forms/agenda-list.vue